import React, {useEffect, useState} from "react";
import Badge from './Badge';
import style from './scss/CasinoItem.module.scss';
import {MainStore, CasinoItemProps} from "../types";
import CasinoDropDown from "./CasinoDropDown";
import {useSelector} from "react-redux";
import CardModal from "./CardModal";
import vars from './scss/Vars.module.scss'
import If from "./BaseComponent/If";

const CasinoItem = ({data, customClass, layout, keyProp, index}: CasinoItemProps) => {
    const [isMobile, setIsMobile] = useState(false);
    const [resizeEventAttached, setResizeEventAttached] = useState(false);
    useEffect(() => {
        setIsMobile(!window.matchMedia(`(min-width: ${vars.lg})`).matches);
        if (!resizeEventAttached) {
            window.addEventListener('resize', () => {
                setTimeout(() => setIsMobile(!window.matchMedia(`(min-width: ${vars.lg})`).matches), 200);
            }, {passive: true})
            setResizeEventAttached(true);
        }
    }, [isMobile, resizeEventAttached])

    const {generalTexts} = useSelector((state: MainStore) => state.casinoListSlice);
    const bg = {"--logo-bg-color": data.logoBg} as React.CSSProperties;
    const bid = data.id
    const isCard = layout === 'cards';
    const [isOpen, setIsOpen] = useState(false);
    const toggleOpen = () => {
        setIsOpen(!isOpen);
    }
    return (
        <li key={keyProp} data-bid={bid} style={bg}
            className={`table-item ${style['table-item']} ${style['casino-item']} ${style[customClass] || ''} ${isOpen ? style['open'] : ''}`}>
            <div
                className={`${style["item-wrapper"]} item-wrapper`}>
                <If condition={isCard}>
                    <div className={`${style['card-header']}`}>
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a data-bs-toggle="modal" data-bs-target={`#modal_${data.id}`} href="#"
                           className={style['information']}>
                            <svg viewBox="0 0 21 20">
                                <use href="#inf"/>
                            </svg>
                        </a>
                        <If condition={!!data.code}>
                            <div className={style['copy-to-clipboard']}>
                                <span
                                    className={`${style['reg']}`}>{generalTexts.code}</span>
                                <strong id={`cpt_${data.id}`}>{data.code}</strong>
                            </div>
                        </If>
                        <If condition={!data.code}>
                            <span className={style['no-code-needed']}>
                                <span>{generalTexts.noCodeNeeded}</span>
                            </span>
                        </If>
                    </div>
                </If>
                <div className={`${style['item-splitter']} item-splitter`}>
                    <div className={style['item-header']}>
                        <If condition={isMobile}>
                            <div className={style['number']}>{index}</div>
                        </If>
                        <div className={style['code-wrapper']}>
                            <If condition={!!data.code}>
                                <>
                                    <div className={style['code-pre-text']}>{generalTexts.code}</div>
                                    <div className={style['code']}>{data.code}</div>
                                </>
                            </If>
                            <If condition={!data.code}>
                                <div className={style['code-pre-text']}>{generalTexts.noCodeNeeded}</div>
                            </If>
                        </div>
                    </div>
                    <div className={style['logo-col']}>
                        <If condition={!isCard}>
                            <div data-table-position={''} className={`${style['number']} number`}>{index}</div>
                        </If>
                        {/* eslint-disable-next-line react/jsx-no-target-blank */}
                        <a className={isMobile ? `${style['go-link']} ${style['stretched-link']} go-link stretched-link` : `${style['review-link']}`}
                           rel={isMobile ? 'nofollow noreferrer' : ''}
                           target={isMobile ? '_blank' : '_self'}
                           data-aff={isMobile ? data.externalAffiliateLink : null}
                           href={isMobile ? data.internalAffiliateLink : data.reviewLink}>
                            <img loading="lazy" src={data.casinoLogo} alt={data.casinoName}/>
                            {data.isExclusive &&
                            <span className={`exclusive ${style.exclusive}`}>{generalTexts.exclusiveBadgeText}</span>
                            }
                        </a>
                    </div>
                    <div className={style['rating-col']}>
                        <If condition={!isCard && !isMobile}>
                            <a href={data.reviewLink} className="stretched-link">
                                <p className={style.text}>{data.casinoName}</p>
                            </a>
                        </If>
                        <If condition={isCard && !isMobile}>
                            <p className={style.text}>{data.casinoName}</p>
                        </If>
                        <div className={style.rating}>
                            <svg viewBox="0 0 49.94 49.94">
                                <use xlinkHref="#star"/>
                            </svg>
                            <div className={style['rating-text']}>{data.rating} / {generalTexts.ratingTopText}</div>
                        </div>
                        <If condition={isMobile}>
                            <div className={style["mobile-bonus-info"]}>
                                <a href={data.reviewLink} className={`${style['casino-name']} stretched-link`}>
                                    {data.casinoName}
                                </a>
                                <div className={style['text-wrap']}>
                                    <If condition={data.bonusCondition.length > 0}>
                                        <p className={style['condition']}>{data.bonusCondition}</p>
                                    </If>
                                    <p className={style['info']}>
                                        <strong
                                            className={style['additional-condition-text']}>{data.bonusInfo}
                                        </strong>
                                    </p>
                                </div>
                                <div className={style['text-wrap']}>
                                    <If condition={data.additionalInfo.length > 0}>
                                        <p className={style['additional-info']}>{data.additionalInfo}</p>
                                    </If>
                                    <p className={style['bonus-type']}>{data.bonusType}</p>
                                </div>
                            </div>
                        </If>
                    </div>
                    <div className={style['bonus-col']}>
                        <p className={style['bonus-name']}>{data.bonusType}</p>
                        <If condition={isCard}>
                            <a className={style['review-link']} href={data.reviewLink}>
                                <p className={style['card-casino-name']}>{data.casinoName}</p>
                            </a>
                        </If>
                        <div className={style['bonus-text-wrapper']}>
                            <p className={style['bonus-condition']}>
                                <If condition={Boolean(data.bonusCondition)}>
                                    <span className={style["text"]}>{data.bonusCondition}</span>
                                </If>
                                <strong className={style['bonus-info']}>{data.bonusInfo}</strong>
                            </p>
                            <If condition={Boolean(data.additionalInfo)}>
                                <p className={style["additional-info"]}>{data.additionalInfo}</p>
                            </If>
                        </div>
                    </div>
                    <div className={`${style["wagering-col"]} wagering-col`}>
                        <If condition={Boolean(data.wageringRequirements) && Boolean(generalTexts.wageringPrefix) && !Boolean(data.payOutSpeed)}>
                            <>
                                <p className={style["wagering-title"]}>{data.wageringRequirements}</p>
                                <p className={style["wagering-prefix"]}>{generalTexts.wageringPrefix}</p>
                            </>
                        </If>
                        <If condition={Boolean(data.payOutSpeed)}>
                            <>
                                <p className={style["wagering-title"]}>{data.payOutSpeed} {generalTexts.days}</p>
                                <p className={style["wagering-prefix"]}>{generalTexts.payOutSpeed}</p>
                            </>
                        </If>
                    </div>
                    <div className={`${style['badge-col']} badge-col`}>
                        <Badge badgeText={data.badgeText} badgeSrc={data.badgeSrc} textClassName={style["badge-text"]}/>
                    </div>
                    <div className={style['toggle-col']}>
                        <a onClick={toggleOpen} className={style['toggle-item']}
                           data-bs-auto-close="true"
                           data-bs-toggle="collapse"
                           href={`#collapse_${data.id}`}
                           role="button"
                           aria-expanded="false" aria-controls="collapseExample">
                            <svg viewBox="0 0 124 124" className={`plus ${style['open-icon']} ${style['plus']}`}>
                                <use xlinkHref="#plus"/>
                            </svg>
                            <svg viewBox="0 0 124 124" className={`minus ${style['open-icon']} ${style['minus']}`}>
                                <use xlinkHref="#minus"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div className={style["cta-col"]}>
                    <a rel="nofollow noreferrer" href={data.internalAffiliateLink}
                       data-aff={data.externalAffiliateLink}
                       className={`go-link r-btn r-btn-larger ${style["prefix-btn"]}`}>{generalTexts.ctaText}
                    </a>
                    <a href={data.reviewLink} className={style["read-review"]}>{generalTexts.readReviewText}</a>
                </div>
            </div>
            <CardModal id={`modal_${data.id}`} data={data}/>
            <CasinoDropDown data={data}/>
        </li>
    );
}

export default CasinoItem;
